import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';

const initialState = {
  addFilterGroupStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  filterGroupData: {},
  isSystemNoteLoading: false,
  systemNotesStatus: null,
  notesuccessMsg: null,
  filterGroupCodeData: [],
};

const filterGroup = createSlice({
  name: 'dmFilterGroup',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchNoteStart: (state) => {
      state.isSystemNoteLoading = true;
      state.errorMsg = null;
    },
    postFilterGroupData: (state, action) => {
      state.addFilterGroupStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    fetchFilterGroup: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.filterGroupData = action.payload;
    },
    fetchFilterGroupCodeData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.filterGroupCodeData = action.payload;
    },
    postSystemNotesData: (state, action) => {
      state.systemNotesStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.notesuccessMsg = action.payload.response;
      state.isSystemNoteLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },

    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.addFilterGroupStatus = null;
      state.filterGroupData = {};
    },
    resetNoteMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.systemNotesStatus = null;
      state.isSystemNoteLoading = false;
    },
    resetFilterData: (state) => {
      state.filterGroupData = {};
    },
  },
});

export default filterGroup.reducer;

const {
  fetchStart,
  fetchError,
  postFilterGroupData,
  resetMsg,
  fetchFilterGroup,
  resetFilterData,
  fetchNoteStart,
  postSystemNotesData,
  resetNoteMessage,
  fetchFilterGroupCodeData,
} = filterGroup.actions;

export const postFilterGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`dmfiltergroup/save/filtergroup`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postFilterGroupData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchFilterGroupData = (filterGroupCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dmfiltergroup/find/filtergroups/${filterGroupCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchFilterGroup(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchFilterGroupCode = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dmfiltergroup/find/all/filtergroupcodeanddescription`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchFilterGroupCodeData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNoteStart());
    httpPost(`dmfiltergroup/save/filtergroupnotes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetFilterGroupData = () => {
  return (dispatch) => {
    dispatch(resetFilterData());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetNoteMessage());
  };
};
